import { buildAnalyticsPath } from "./buildAnalyticsPath";
import type { AnalyticsApiParams } from "./types";

export const live = {
  events_completed: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "events_completed", params),
  total_rsvps: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "total_rsvps", params),
  live_attendance: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "live_attendance", params),
  tickets_sold: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "tickets_sold", params),
  event_revenue: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "event_revenue", params),
  popular_times: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "popular_times", params),
  event_activity: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "event_activity", params),
  popular_events: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "popular_events", params),
  top_attendees: (params: AnalyticsApiParams) =>
    buildAnalyticsPath("live", "top_attendees", params),
};
